module.exports = ['$scope', '$stateParams', 'curriculumManager', 'settings', 'ngMeta', '$state',
  function ($scope, $stateParams, curriculumManager, settings, ngMeta, $state) {
    'use strict';

    curriculumManager.getFieldById($stateParams.fieldKey).then(function (field) {
      if (typeof field === 'undefined') {
        $state.go('notFound', {}, { location: false });
      }
      $scope.field = field;
      ngMeta.setTitle(field.title);
      ngMeta.setTag('description', field.description);
      ngMeta.setTag('image', field.coverUrl);

      const url = field.attachments.filter(o => o.type === 'VIDEO')[0].playbackUrl;
      if (url !== undefined && url != '') {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
        var match = url.match(regExp);
        if (match && match[2].length === 11) {
          $scope.playbackUrl = 'https://youtube.com/embed/' + match[2];
        }
      }

    });
  }
];



// WEBPACK FOOTER //
// ./web/js/screen/leerinhoud/field/leerinhoudFieldController.js